export const VALIDATION_MESSAGES_ARTICLE_URL = 'https://learn.thryv.com/hc/en-us/articles/44732618517261-Solution-Launchpad-Understanding-Validation-Messages';
export const CONTACT_SUPPORT_URL = 'https://keap.com/contact';
export const MANAGING_PERMISSIONS_URL = 'https://learn.thryv.com/hc/en-us/articles/37356210718221-Roles-and-Permissions#h_01JXN3YG64CP7ZJ34SX0PMHZ6Y';
